export default __webpack_public_path__ + "static/media/anxiety.2b677c67.png";